function deptMapping(data = {}, index) {

  return {
    key: index,
    deptId: data.DEPT_ID ? data.DEPT_ID : null,
    deptName: data.DEPT_NAME_TH ? data.DEPT_NAME_TH : null,
  }
}
export default deptMapping
